




























import { Component , Vue } from 'vue-property-decorator';
import { ToastEvent } from '../types/event';
import { EventBus } from '../main';
import { MedTransGoConstants } from '../util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest } from '@/types/request';
import { CommonUtils } from '@/util/commonUtils';
import { DateUtils } from '@/util/dateUtils';
import '../assets/css/SessionTimeout.scss';
@Component({})
export default class SessionTimeout extends Vue {
    private show = true;
    private timeCounter: number = 60;
    private timerId: any = undefined;
    private mounted() {
        this.timeCounter = 60;
        this.timerId = setInterval(() => {
            this.timeCounter--;
            if (this.timeCounter < 1) {
                clearInterval(this.timerId);
                this.$emit('logout');
            }
        }, 1000);
    }

    private async continueSession(client: any) {
        clearInterval(this.timerId);
        this.$emit('close');
    }

    private logout() {
        const redirectUrl = `${this.$store.state.serverUrl}${MedTransGoConstants.HTTP_URL_LOGIN}?clientId=${this.$store.state.clientId}`;
        location.href = redirectUrl;
        ObjectFactory.getCacheService().clearCache();
    }
}
